import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import { useT } from "@transifex/react";

interface BookSearchFieldProps {
    query: string;
    onQueryChange: (query: string) => void;
}

/** One search for every step: titles, publishers and ISBNs, as the teacher types. The stepper below is the other way. */
const BookSearchField = (props: BookSearchFieldProps) => {
    const t = useT();
    const t_title = t("Find a textbook directly", { _tags: "CreateTest,SelectBook" });
    const t_placeholder = t("Search title, publisher or ISBN", { _tags: "CreateTest,SelectBook" });

    return (
        <label className="flex flex-col gap-s">
            <span className="text-l font-semibold text-p6-grey-dark">{t_title}</span>
            <span className="relative flex items-center rounded-button border-2 border-solid border-p6-grey-light bg-white focus-within:outline-2 focus-within:outline-creation-primary">
                <MagnifyingGlassIcon
                    aria-hidden="true"
                    className="pointer-events-none absolute left-xs text-l text-p6-grey-mid"
                />
                <input
                    type="search"
                    value={props.query}
                    onChange={(event) => props.onQueryChange(event.target.value)}
                    placeholder={t_placeholder}
                    className="w-full rounded-button border-none bg-transparent py-xs pl-l pr-s text-m text-p6-grey-dark outline-none placeholder:text-p6-grey-mid [&::-webkit-search-cancel-button]:cursor-pointer"
                    data-testid="book-selection-search"
                />
            </span>
        </label>
    );
};

export default BookSearchField;
